import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AssetDepreciationRate  {
    _originalTypeClassName = "zERP.BO.AssetDepreciationRate";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AssetDepreciationRate.translate = translateService;
}
this.Rates = [];
this.LatestRate = new Domain.AssetDepreciationRateRate();
this.Id = null;
this.Code = null;
this.Description = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Description:any;
Rates:any;
LatestRate:any;
static setRates = ($this, items) => {
                if (items == null) items = [];
                if ($this.Rates == null) $this.Rates = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Rates.length > 0) {
                    Domain.AssetDepreciationRate.removeRates($this, $this.Rates[0]);
                }

                Domain.AssetDepreciationRate.addManyRates($this, copyItems);
            }
static addManyRates = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AssetDepreciationRate.addRates($this, items[i]);
                }
            }
static addRates = ($this, item) => {
                if ($this.Rates == null) $this.Rates = [];
                if (item == null || $this.Rates.indexOf(item) > -1) return;
                $this.Rates.push(item);
}
static addRangeRates = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AssetDepreciationRate.addRates($this, item));
            }
static removeRates = ($this, item) => {
                if ($this == null || $this.Rates == null || $this.Rates.indexOf(item) === -1) return;
                var _index = $this.Rates.indexOf(item);
                $this.Rates.splice(_index, 1);
}
static clearRates = ($this) => { $this.Rates = null; }
static setLatestRate = ($this, value) => {
var oldValue = $this.LatestRate;
$this.LatestRate = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}